<style lang="scss" scoped>
</style>
<template>
    <div>
        <jijiu-page-title title="车辆管理">
            <div class="ml10">
                <el-button size="mini" type="primary" @click="add">添加车辆</el-button>
            </div>
        </jijiu-page-title>
        <div class="mt10">
            <el-table size="mini"
                      border
                      :data="list"
                      style="width: 100%">
                <el-table-column
                    type="index"
                    width="50">
                </el-table-column>
                <el-table-column
                    label="是否启用"
                    width="180">
                    <template slot-scope="{row}">
                        <span :class="[row.enabled_class]">{{row.enabled_text}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="hosName"
                    label="所属医院"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="ambulanceTypeText"
                    label="车辆类型"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="ambulanceName"
                    label="车辆名称"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="licensePlateNo"
                    label="车牌号"
                    width="180">
                </el-table-column>
                <el-table-column
                    label="操作">
                    <template slot-scope="{row}">
                        <el-button type="text" size="mini" @click="startOrstop(row)">{{row.opera_btn}}</el-button>
                        <el-button type="text" size="mini" @click="modify(row)">修改</el-button>
                        <!--<el-button type="text">详情</el-button>-->
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="mt10">
            <el-pagination
                background
                :page-size="page.pageSize"
                layout="total, prev, pager, next"
                :total="page.total"
                :current-page="page.pageNum"
                @current-change="getList">
            </el-pagination>
        </div>
        <add-car-dialog ref="add"></add-car-dialog>
    </div>
</template>
<script>
  import JijiuPageTitle from "../components/jijiu-page-title";
  import {staffService} from "../service/staff";
  import AddCarDialog from "../components/add-car-dialog";
  import {STAFF_ADD_CAR_SUCCESS} from "../events";

  export default {
    name: 'jijiu-cheliang',
    components: {AddCarDialog, JijiuPageTitle},
    data() {
      return {
        list: [],
        page: {
          pageNum: 1,
          pageSize: 10
        }
      }
    },
    created() {
      bus.$on(STAFF_ADD_CAR_SUCCESS.id, this.getList);

      this.getList();
    },
    beforeDestroy() {
      bus.$off(STAFF_ADD_CAR_SUCCESS.id, this.getList);
    },
    methods: {
      add() {
        this.$refs.add.show();
      },
      modify(data) {
        this.$refs.add.show(data);
      },
      startOrstop(data) {
        this.$confirm(`是否${data.opera_btn} ${data.ambulanceName}?`)
          .then(async () => {
            if (await staffService.startOrStopCar(!data.enabled, data.id)) {
              this.getList();
            }
          })
      },
      async getList(pageNum) {
        const {page: p} = this;
        Log('p', p, pageNum);
        const {list, page} = await staffService.listCar({
          pageSize: p.pageSize,
          pageNo: parseInt(pageNum) || p.pageNum || 1
        });
        this.list = list;
        this.page = page;
      }
    },
  }
</script>
